import { ROUTES } from "@/shared/constants";

/** Full page load — resets client auth/layout state for a reliable registration flow. */
export function navigateToRegisterTalent() {
  window.location.assign(ROUTES.REGISTER_TALENT);
}
